<template>
  <div>
    <section
      class="wf100 subheader"
      style="margin-bottom: 10px; background: #048042"
    >
      <div class="container">
        <h2>فرص العمل</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li v-if="this.$route.params.id">المنظمة</li>
          <li>فرص العمل</li>
        </ul>
      </div>
    </section>

    <div class="main-content general-activities">
      <!-- <main-header /> -->
      <div class="container filter_small_screen">
        <collapse-header title_img="filter" title="بحث بحسب">
          <div class="m-2">
            <div>
              <form-select
                label="مجال العمل"
                v-model="filter.position_type_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="jobs_position"
                ep="v2/guest/selects/positions"
              />
              <form-autocomplete
                class="w-25 mx-25"
                label="المنظمة"
                :dir="'rtl'"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filter.ngo_id"
                ep="v2/guest/filter-name"
                id="jobs_ngos"
                filterKey="name_ar"
                placeholder="ابدأ بالكتابة للبحث"
                v-if="!this.$route.params.id"
              />
              <form-select
                label="المحافظة"
                v-model="filter.governorate_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="jobs_governorate"
                ep="v2/guest/selects/governorates"
              />
              <b-form-group
                label="طبيعة الألتزام"
                style="
                  margin-top: 2.6rem !important;
                  margin-bottom: 2.6rem !important;
                "
              >
                <b-form-radio-group
                  v-model="filter.employment_type"
                  :options="optionsContractWork"
                  name="radios-stacked"
                  stacked
                />
              </b-form-group>
              <div class="d-flex justify-content-between">
                <b-button variant="primary" @click="onFilterReset"
                  >إلغاء البحث</b-button
                >
                <b-button variant="info" @click="onFilterSubmitted"
                  >بحث</b-button
                >
              </div>
            </div>
            <!-- </basc-card> -->
          </div>
        </collapse-header>
      </div>

      <div class="events-listing">
        <div class="container">
          <div>
            <div style="display: flex; margin-top: 30px; min-height: 70vh">
              <div class="min_filter">
                <div class="m-2">
                  <basc-card style="width: 300px; min-height: 400px">
                    <div>
                      <div class="d-flex align-item-center">
                        <feather-icon
                          icon="FilterIcon"
                          size="17"
                          class="mx-25"
                        />
                      </div>
                      <hr />
                      <form-select
                        label="مجال العمل"
                        v-model="filter.position_type_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        id="jobs_position"
                        ep="v2/guest/selects/positions"
                      />

                      <form-autocomplete
                        class="w-25 mx-25"
                        label="المنظمة"
                        :dir="'rtl'"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        v-model="filter.ngo_id"
                        ep="v2/guest/filter-name"
                        id="jobs_ngos"
                        filterKey="name_ar"
                        placeholder="ابدأ بالكتابة للبحث"
                        v-if="!this.$route.params.id"
                      />
                      <form-select
                        label="المحافظة"
                        v-model="filter.governorate_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        id="jobs_governorate"
                        ep="v2/guest/selects/governorates"
                      />
                      <b-form-group
                        label="طبيعة الألتزام"
                        style="
                          margin-top: 2.6rem !important;
                          margin-bottom: 2.6rem !important;
                        "
                      >
                        <b-form-radio-group
                          v-model="filter.employment_type"
                          :options="optionsContractWork"
                          name="radios-stacked"
                          stacked
                        />
                      </b-form-group>
                      <div class="d-flex justify-content-between">
                        <b-button variant="primary" @click="onFilterReset"
                          >إلغاء البحث</b-button
                        >
                        <loader-btn
                          variant="info"
                          @click="onFilterSubmitted"
                          :loading="loading"
                          label="بحث"
                          loadingLabel="جاري البحث ..."
                          noIcon
                        ></loader-btn>
                      </div>
                    </div>
                  </basc-card>
                </div>
              </div>
              <div v-if="loading" class="w-100">
                <basc-card v-for="n in 3" :key="n">
                  <b-skeleton
                    animation="fade"
                    height="22px"
                    width="25%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>

                  <div class="d-flex justify-content-end">
                    <b-skeleton type="button"></b-skeleton>
                  </div>
                </basc-card>
              </div>
              <div style="width: 100%; margin-top: 8px" v-else>
                <Job
                  v-for="item in jobs"
                  :key="item.id"
                  :id="item.id"
                  :name="item.name"
                  :ngo_name="item.ngo_name"
                  :position_type="item.positionType.name_ar"
                  :vacancies_number="item.code"
                  :closing_date="item.closing_date"
                  :starting_date="item.starting_date"
                  :governorate="item.governorate.name_ar"
                  :code="item.code"
                  job="jobs"
                ></Job>
                <alert
                  v-if="jobs.length == 0 && !loading"
                  :massage="$t('alert')"
                  class="w-100"
                ></alert>
                <pagination
                  v-if="pagination.total_row"
                  class="mt-2"
                  v-model="filter.page"
                  :total-rows="pagination.total_row"
                  :per-page="pagination.per_page"
                  align="center"
                >
                </pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loaderBtn from "@/components/loader-btn";
import NotItem from "../../components/NotItem.vue";
import vSelect from "vue-select";
import Job from "../../components/Job.vue";
import BascCard from "../../components/BascCard.vue";
import CollapseHeader from "../../../../@core/components/app-collapse/CollapseHeader.vue";
import { mapGetters, mapActions } from "vuex";
import Pagination from "@/components/pagination";

import {
  BFormRadioGroup,
  BCardText,
  BFormGroup,
  BFormSelect,
  BButton,
  BSkeleton,
  BPaginationNav,
} from "bootstrap-vue";
import Alert from "../../../../components/Alert.vue";
import formAutocomplete from "@/components/form-autocomplete";
import FormSelect from "@/components/form-select";

export default {
  components: {
    Job,
    BFormRadioGroup,
    BFormGroup,
    BFormSelect,
    NotItem,
    vSelect,
    BButton,
    BascCard,
    CollapseHeader,
    formAutocomplete,
    FormSelect,
    Alert,
    BSkeleton,
    BPaginationNav,
    Pagination,
    loaderBtn,
    BCardText,
  },
  props: ["id"],
  data() {
    return {
      filter: {
        page: 1,
        ngo_id: this.id,
      },
      optionsContractWork: ["دوام كامل", "دوام جزئي", "عن بعد"],
    };
  },
  computed: {
    ...mapGetters("NgoHome/jobs", ["jobs", "loading", "pagination"]),
  },
  methods: {
    ...mapActions("NgoHome/jobs", ["getJobs"]),
    onFilterSubmitted() {
      this.getJobs(this.filter);
    },
    onFilterReset() {
      this.filter = {
        page: 1,
        ngo_id: this.id,
      };
      this.getJobs(this.filter);
    },
  },

  watch: {
    "filter.page"() {
      this.getJobs(this.filter);
    },
  },

  created() {
    this.getJobs(this.filter);
  },
};
</script>

<style lang="scss">
.custom-radio {
  margin: 5px;
}
.title {
  font-family: Almarai, sans-serif;
  font-weight: 400;
  letter-spacing: 0.00735em;
  line-height: 2.5rem;
  color: #82868b;
  // padding-top: 10px;
}
.filter_small_screen {
  display: none;
}
@media (max-width: 1030px) {
  .min_filter {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
</style>
